import React from 'react';
import InlineFeedbackBase from './InlineFeedbackBase';

import TInlineFeedback from './types/TInlineFeedback';
import TEFeedbackSignal from '../../types/TEFeedbackSignal';

const Success = ({ children, ...rest }: TInlineFeedback) => (
  <InlineFeedbackBase {...rest} signal={TEFeedbackSignal.Success}>
    {children}
  </InlineFeedbackBase>
);

export default Success;
